export const actions = {
  HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_REQUESTED:
    'HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_REQUESTED',
  HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_SUCCEEDED:
    'HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_SUCCEEDED',
  HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_FILED:
    'HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_FILED',

  HORARIO_ENTREGA_MRW_UPDATE_REQUESTED: 'HORARIO_ENTREGA_MRW_UPDATE_REQUESTED',
  HORARIO_ENTREGA_MRW_UPDATE_SUCCEEDED: 'HORARIO_ENTREGA_MRW_UPDATE_SUCCEEDED',
  HORARIO_ENTREGA_MRW_UPDATE_FILED: 'HORARIO_ENTREGA_MRW_UPDATE_FILED',

  HORARIO_ENTREGA_MRW_INSERT_REQUESTED: 'HORARIO_ENTREGA_MRW_INSERT_REQUESTED',
  HORARIO_ENTREGA_MRW_INSERT_SUCCEEDED: 'HORARIO_ENTREGA_MRW_INSERT_SUCCEEDED',
  HORARIO_ENTREGA_MRW_INSERT_FILED: 'HORARIO_ENTREGA_MRW_INSERT_FILED',

  HORARIO_ENTREGA_MRW_DELETE_REQUESTED: 'HORARIO_ENTREGA_MRW_DELETE_REQUESTED',
  HORARIO_ENTREGA_MRW_DELETE_SUCCEEDED: 'HORARIO_ENTREGA_MRW_DELETE_SUCCEEDED',
  HORARIO_ENTREGA_MRW_DELETE_FILED: 'HORARIO_ENTREGA_MRW_DELETE_FILED',
}

export const getHorariosEntregaMRWByUbicacionIdAction = (dispatch, ubicacionesIds) => {
  dispatch({
    type: actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_REQUESTED,
    payload: ubicacionesIds,
  })
}

export const onSubmitInsertHorarioEntregaMRWFormAction = (dispatch, formHorarioEntregaMRW) => {
  dispatch({
    type: actions.HORARIO_ENTREGA_MRW_INSERT_REQUESTED,
    payload: formHorarioEntregaMRW,
  })
}

export const onSubmitUpdateHorarioEntregaMRWFormAction = (dispatch, formHorarioEntregaMRW) => {
  dispatch({
    type: actions.HORARIO_ENTREGA_MRW_UPDATE_REQUESTED,
    payload: formHorarioEntregaMRW,
  })
}

export const deleteHorarioEntregaMRWAction = (dispatch, id) => {
  dispatch({
    type: actions.HORARIO_ENTREGA_MRW_DELETE_REQUESTED,
    payload: id,
  })
}
